import React from "react"
import {legacyImageURL} from "components/LegacyImage"
import analytics from "global/AnalyticsData"


import "./Landing.scss"
import BreakHTMLFooter from 'steps/BreakHTMLFooter'

import CircleArrowSVG from 'images/inline/arrow-button.svg'

/*

Landing page
Pure UI/render here. all logic handled by LandingStep.jsx
welcome message and a start button

*/

const LandingStep = ({ brk, onAttemptStart, onStartClick, isEmbed, hasLogo, HtmlFooter}) => {
    // console.log(brk)

    // console.log('title: ',brk.title)
    // console.log('desc: ', brk.mapDescription)

    const arrowButtonHandler = async (e) => {
        console.log(`event: landing_start_button_click fired`)
        // before we actually start, run this up the flag pole to make sure we're ok to start (user is logged in)
        const okToStart = await onAttemptStart('landing')
        console.log(`okToStart: `, okToStart)

        if (okToStart === true) {
            analytics.breakEvent("landing_start_button_click", brk )
            onStartClick()      
        }
    }
    // temporary cleanup:
    // new data coming in has a field brk.hasBackgroundOverlay set to true by default
    // cached data doesn't have this field, so it will be undefined (or falsy)
    // so if it's undefined, make it default (true)
    if (brk.hasBackgroundOverlay === undefined) {
        brk.hasBackgroundOverlay = true
    }

    let stepStyle = {}

    if (brk.backgroundColor) {
        stepStyle.backgroundColor = brk.backgroundColor;
    }

    if (brk.backgroundImageId) {
        stepStyle.backgroundImage = `url(${process.env.SITE_ASSET_URL}/${brk.backgroundImageId})`
    }
    const allFooterMarkup = () => {
       let ret = ""
       if (brk && brk.footerHtml) {
           ret = ret + brk.footerHtml
       }
       if (brk && brk.landingPageFooterHtml) {
           ret = ret + brk.landingPageFooterHtml
       }
       return ret
       
    }

    return (

        <div className={`landing-step-new step-landing-new sponsored-flow-panel logo-${hasLogo} overlay-${brk.hasBackgroundOverlay ? '1' : '0'}`} style={stepStyle}>
            <div className="landing-new-component">

                <div className="content-wrapper">
                    <div className="content">
                        <p className="activity">Activity: {brk.steps.length} steps
                            { !isEmbed &&
                                <span><span className="activity-separator">|</span> {(brk.steps.length * 4)} points </span>
                            }
                        </p>
                        { (brk.mapHeadlineType === "IMAGE") && (
                            <>
                                <img className='for-desktop-only' src={legacyImageURL(brk.mapHeadlineImage)} alt={brk.mapHeadline} />
                                <h1 className='for-mobile-only' dangerouslySetInnerHTML={{__html: brk.mapHeadline}} />
                            </>
                        )}
                        { (brk.mapHeadlineType === "TEXT") && (
                            <h1 dangerouslySetInnerHTML={{__html: brk.mapHeadline}} />
                        )}

                      
                        { brk.mapDescription &&
                            <p dangerouslySetInnerHTML={{__html: brk.mapDescription}} />
                        }
                        { !brk.mapDescription && brk.mapDescriptionMobile &&
                            <p dangerouslySetInnerHTML={{__html: brk.mapDescriptionMobile}} />
                        }

                        { isEmbed &&
                            <p className="terms">By clicking into the experience, I acknowledge that I have read and agree to be bound by the Breaktime Media MWH, LLC <a href="/terms/" target="_blank">Terms &amp; Conditions</a> and <a href="/privacy/" target="_blank">Privacy Policy.</a></p>
                        }

                        <p>
                            {/* <span className="btn start-button" onClick={arrowButtonHandler}>Start</span> */}
                            <button className="arrow-button2" onClick={arrowButtonHandler}>
                                <CircleArrowSVG />
                            </button>
                        </p>
                    </div>
                    <BreakHTMLFooter content={allFooterMarkup()}/>
                </div>
                
            </div>

        </div>

    )

}
export default LandingStep